interface DiscountOptions {
  isPromoActive: boolean
  discountPromo: number
  discountDefault: number
  dateStart: string | null
  dateEnd: string | null
  discount: number

  isDefaultDiscount: boolean
  promoLabel: string | null
}

const cache: {
  data: DiscountOptions | null,
  promise: Promise<DiscountOptions> | null,
} = {
  data: null,
  promise: null,
};

export async function fetchOptions(): Promise<DiscountOptions> {
  if (cache.data) {
    return Promise.resolve(cache.data);
  }

  if (!cache.promise) {
    const req = $fetch<DiscountOptions>("/api/options", {
      cache: "reload",
    });

    cache.promise = req.then((res) => {
      cache.data = res;
      return res;
    });
  }

  return cache.promise;
}
